import React from "react";
import { useState, useEffect } from "react";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import "../style/menu.css";
export default function Menu({ sendDatatoDash }) {
  const [value, setValue] = useState(0);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    sendDatatoDash(newValue);
  };

  return (
    <div className="Menu">
      <div className="menu-list">
        <Tabs
          value={value}
          aria-label="basic tabs example"
          onChange={handleChangeTab}
          orientation="vertical"
        >
          <Tab label="Orders" {...a11yProps(0)} />
          <Tab label="Products" {...a11yProps(1)} />
        </Tabs>
        {/* <div className="dashboard-btn box">Dashboard</div>
        <div className="dashboard-btn box">Products</div>
        <div className="dashboard-btn box">Orders</div> */}
        {/* <div className="dashboard-btn box">Account</div>
        <div className="dashboard-btn box">Settings</div> */}
      </div>

      {/* <div className="config-list">
        <div className="dashboard-btn box">Appearance</div>
        <div className="dashboard-btn box">Settings</div>
      </div> */}
    </div>
  );
}
